import { render, staticRenderFns } from "./reviewManageRubric.vue?vue&type=template&id=d5ce9d8c&"
import script from "./reviewManageRubric.vue?vue&type=script&lang=ts&"
export * from "./reviewManageRubric.vue?vue&type=script&lang=ts&"
import style0 from "./reviewManageRubric.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports